import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IconButton, Menu, MenuItem, ListItemText } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";

const LanguageSwitcher = ({ languages }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { lang } = useParams();
  const [anchorEl, setAnchorEl] = React.useState(null);

  // κρατάμε το path χωρίς το prefix γλώσσας
  const pathAfterLang = location.pathname.replace(/^\/[a-z]{2}(\/|$)/, "/");

  const open = Boolean(anchorEl);
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (code) => {
    handleClose();
    navigate(`/${code}${pathAfterLang}`);
  };

  return (
    <>
      <IconButton
        color="inherit"
        size="large"
        aria-label="change language"
        onClick={handleOpen}
        sx={{ p: 1 }}
      >
        <TranslateIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { minWidth: 160 } }}
      >
        {languages.map((lng) => (
          <MenuItem
            key={lng.code}
            selected={lng.code === lang}
            onClick={() => handleSelect(lng.code)}
          >
            <ListItemText
              primary={lng.label}
              primaryTypographyProps={{ fontSize: 14 }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
